//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VueClazyLoad } from 'vue-clazy-load'
import { generateFootballPageSchema } from '~/utils/schema'
const sports = require('~/data/sports.json')

export default {
  head() {
    const slug =
      (this.$route && this.$route.params && this.$route.params.sport) ||
      (this.sport && this.sport.slug) ||
      ''
    const normalized = String(slug).toLowerCase()
    const isFutbol = ['futbol', 'football', 'soccer'].includes(normalized)

    if (!isFutbol) return {}

    return {
      script: [
        {
          type: 'application/ld+json',
          json: this.generateSchema()
        }
      ]
    }
  },
  components: {
    VueClazyLoad
  },
  data() {
    return {
      sport: {},
      sections: [],
      mode: 'competitions',
      loading: true,
      competitions: [],
      featured_competitions: [],
      selectedPeriod: null,
      periods: [
        { value: 1, label: '1hr' },
        { value: 24, label: '24hr' },
        { value: 24 * 4, label: '4 days' },
        { value: 24 * 7, label: '7 days' },
        { value: null, label: 'All' }
      ],
      savingMap: {}
    }
  },
  computed: {
    sportKey() {
      return String(this.sport?.id ?? this.$route.params.sport ?? '')
    },
    favSet() {
      const dict = this.user?.favorite_competitions || {}
      const ids = Array.isArray(dict[this.sportKey]) ? dict[this.sportKey] : []
      return new Set(ids.map(Number))
    },
    favIdsForSport() {
      const dict = this.user?.favorite_competitions || {}
      const arr = Array.isArray(dict[this.sportKey]) ? dict[this.sportKey] : []
      return arr.map(Number)
    },
    favoriteCompetitions() {
      const all = [...this.featured_competitions, ...this.competitions]
      const byId = new Map(all.map(c => [Number(c.competition_id || c.id), c]))
      return this.favIdsForSport
        .map(id => byId.get(id))
        .filter(Boolean)
    },
    hasFavoriteCompetitions() {
      return this.favoriteCompetitions.length > 0
    },
    featuredWithoutFav() {
      return this.featured_competitions.filter(c => !this.favSet.has(this.compId(c)))
    },
    competitionsWithoutFav() {
      const featuredIds = new Set(this.featured_competitions.map(c => this.compId(c)))
      return this.competitions.filter(c => {
        const id = this.compId(c)
        return !this.favSet.has(id) && !featuredIds.has(id)
      })
    },
    orderedCompetitionItems() {
      const items = []

      // 1) Favorites block on top
      if (this.favoriteCompetitions.length) {
        items.push({
          type: 'header',
          id: 'fav-header',
          label: this.$t('Favorites')
        })

        this.favoriteCompetitions.forEach(c => {
          items.push({
            type: 'row',
            id: 'c-' + this.compId(c), // same key across all sections
            competition: c
          })
        })
      }

      // 2) Featured block (without favorites)
      if (this.featuredWithoutFav.length) {
        items.push({
          type: 'header',
          id: 'featured-header',
          label: this.$t('Featured')
        })

        this.featuredWithoutFav.forEach(c => {
          items.push({
            type: 'row',
            id: 'c-' + this.compId(c),
            competition: c
          })
        })
      }

      // 3) All competitions block (without favorites)
      if (this.competitionsWithoutFav.length) {
        items.push({
          type: 'header',
          id: 'all-header',
          label: this.$t('All competitions')
        })

        this.competitionsWithoutFav.forEach(c => {
          items.push({
            type: 'row',
            id: 'c-' + this.compId(c),
            competition: c
          })
        })
      }

      return items
    }
  },
  async fetch() {
    try {
      const params = {
        ...this.$route.params,
        lang: this.lang
      }

      const response = await this.$content().get('breadcrumbs', { params })
      this.$store.commit('seo/setVariables', {
        sport: _.get(response.data.data, 'sport.name')
      })

      if (_.get(this.$route, 'query.mode')) {
        await this.selectMode(this.$route.query.mode)
      } else {
        await this.selectMode('competitions')
      }
    } catch (e) {
      console.log(e.message)
    }
  },
  methods: {
    generateSchema() {
      if (this.$route.path === '/futbol/') {
        return generateFootballPageSchema()
      }
      return {}
    },
    getURL(competition, mode) {
      if (mode === 'outrights') {
        return this.localePath({
          name: 'sport-competition-outrights',
          params: { competition: competition.translated_slug }
        })
      }
      return this.localePath({
        name: 'sport-competition',
        params: { competition: competition.translated_slug }
      })
    },
    async selectPeriod(period) {
      this.selectedPeriod = period
      await this.fetchCompetitions()
    },
    async selectMode(mode) {
      this.mode = mode
      this.selectedPeriod = null
      await this.fetchCompetitions()
    },
    async fetchCompetitions() {
      this.loading = true

      try {
        const response = await this.$content().get('collections/competitions', {
          params: {
            bookmaker: this.$config.BOOKMAKER,
            lang: this.lang,
            country: this.country,
            sport: this.$route.params.sport,
            period: this.selectedPeriod,
            mode: this.mode,
            eager: '[region,sport]',
            orderBy: 'region.slug'
          }
        })

        this.competitions = _.get(response, 'data.data.competitions', [])
        this.sections = _.get(response, 'data.data.sections', [])

        // Ensure "favorites" tab exists
        if (!this.sections.includes('favorites')) {
          this.sections.push('favorites')
        }

        this.featured_competitions = _.orderBy(
          _.filter(this.competitions, { featured: true }),
          ['position'],
          ['asc']
        )
        this.sport = _.get(response, 'data.data.sport', [])

        if (this.sport && this.sport.slug === 'tennis') {
          this.competitions = _.orderBy(this.competitions, ['position'], ['asc'])
        }

        if (_.size(this.competitions) === 0 && _.includes(this.sections, 'outrights')) {
          await this.selectMode('outrights')
        } else {
          this.loading = false
        }
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    toNum(v) {
      return Number(v)
    },
    isSaving(id) {
      return !!this.savingMap[this.toNum(id)]
    },
    setSaving(id, val) {
      const nid = this.toNum(id)
      if (val) this.$set(this.savingMap, nid, true)
      else this.$delete(this.savingMap, nid)
    },
    async toggleCompetitionFavorite(competition) {
      const id = this.compId(competition)
      const sport_slug = this.$route.params.sport

      if (!this.user) {
        this.$modal.show('modal-login')
        return
      }
      if (this.isSaving(id)) return

      this.setSaving(id, true)

      try {
        const { data } = await this.$auth().post('/api/sport/favorites/competitions', {
          id_competition: id,
          sport_slug
        })

        if (!data?.result) {
          console.error('toggleCompetitionFavorite error', data)
          return
        }

        const serverId = this.toNum(data.id_competition)
        const action = data.action
        const applyId = Number.isNaN(serverId) ? id : serverId

        if (action === 'add') {
          this.$store.commit('auth/addFavoriteCompetition', {
            sportKey: sport_slug,
            id: applyId
          })
        } else if (action === 'delete') {
          this.$store.commit('auth/removeFavoriteCompetition', {
            sportKey: sport_slug,
            id: applyId
          })
        }
      } catch (e) {
        console.error('toggleCompetitionFavorite exception', e)
      } finally {
        this.setSaving(id, false)
      }
    },
    compId(c) {
      return Number(c.competition_id || c.id)
    },
    isCompetitionFavorite(c) {
      return this.favSet.has(this.compId(c))
    }
  }
}
